import React, { FC } from 'react';

import { CheckListContainerProps } from '.';
import { CheckListProps, ICheckListProps } from './checklist/CheckList';

/**
 * @example
 * checkLists: [
 *    {
 *      someOtherProp: "Foo",
 *      item_01: "Bar",
 *      item_02: "Baz",
 *      item_n:  "...",
 *      ...
 *    },
 * ]
 * =>
 * { checkLists: [
 *    {
 *      someOtherProp: "Foo",
 *      listItems: ["Bar", "Baz", ...]
 *      ...
 *    },
 * ] }
 */

export const CheckListContainerAdapter = (
  CheckListContainer: FC<CheckListContainerProps>
) => {
  return function checkListContainerAdapter({
    checkLists,
    ...rest
  }: CheckListContainerProps) {
    const checkListsAdapted: ICheckListProps[] =
      checkLists?.map((checkList) => {
        const checkListAdapted: any = { listItems: [] };
        Object.entries(checkList)
          .sort()
          .forEach(([key, value]) => {
            if (key.startsWith('item_')) {
              value && checkListAdapted.listItems.push(value.toString());
            } else {
              checkListAdapted[key] = value;
            }
          });

        return checkListAdapted;
      }) ?? [];
    return <CheckListContainer {...rest} checkLists={checkListsAdapted} />;
  };
};
